import {
  HeaderWrapper,
  InnerContainer,
  TextWrapper,
  TitleWrapper,
} from "./styled";
import { Text } from "../../../library/text";
import { Title } from "../../../library/title";

const Header = () => {
  return (
    <HeaderWrapper>
      <InnerContainer>
        <TitleWrapper>
          <Title size="xl">Priser for bruk</Title>
        </TitleWrapper>
        <TextWrapper>
          <Text color="dark">
            Hos Randi kan du registrere deg en konto helt gratis uten å måtte
            legge inn kortinformasjon. Som gratisbruker får du opp til 4 gratis
            transkriberinger per måned med en grense på 20 minutters varighet
            per video. Har du behov for mer kan du oppgradere til følgende:
          </Text>
        </TextWrapper>
      </InnerContainer>
    </HeaderWrapper>
  );
};

export default Header;
